export default __webpack_public_path__ + "static/media/error_worning_small.850c592d.svg";